import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  COOKIE_CONSENT_STORAGE_KEY,
  COOKIE_CONSENT_BANNER_TEXT,
  COOKIE_POLICY_LINK_TEXT,
  SECURITY_POLICY_ROUTE,
} from "../../utils/cookies";
import "./CookieConsentBanner.scss";

export const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY) === "1") return;
    } catch {}
    setVisible(true);
  }, []);

  const accept = useCallback(() => {
    try {
      localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, "1");
    } catch {}
    setVisible(false);
  }, []);

  if (!visible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-label="Согласие на использование cookie" aria-live="polite">
      <div className="cookie-consent-inner">
        <p className="cookie-consent-text">
          {COOKIE_CONSENT_BANNER_TEXT}{" "}
          <Link to={SECURITY_POLICY_ROUTE} className="cookie-consent-more">
            {COOKIE_POLICY_LINK_TEXT}
          </Link>
          .
        </p>
        <button type="button" className="cookie-consent-accept" onClick={accept}>
          Принять
        </button>
      </div>
    </div>
  );
};
